"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManagersService = void 0;
class ManagersService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Returns available all avaialable users
     * @returns UserManagerResponse
     * @throws ApiError
     */
    getAllUsers() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/managers/users/all',
        });
    }
    /**
     * Returns available users for manager.
     * @param managerId
     * @returns UserManagerResponse
     * @throws ApiError
     */
    getManagerUsers(managerId) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/managers/users',
            query: {
                'managerId': managerId,
            },
        });
    }
    /**
     * Returns manager stats information.
     * @returns ManagersStatsResponse
     * @throws ApiError
     */
    getManagersStats() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/managers/stats',
        });
    }
    /**
     * Returns managers information.
     * @param parts Manager relation atributes list
     * @returns ManagerResponse
     * @throws ApiError
     */
    getManagers(parts) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/managers/',
            query: {
                'parts[]': parts,
            },
        });
    }
    /**
     * Create manager information by id.
     * @param requestBody
     * @returns CreateManagerRes
     * @throws ApiError
     */
    createManager(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/managers/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * list all managers paginated with filters and sort.
     * @param parts Manager relation atributes list
     * @param filtersjson filtersjson is the ListManagersRequestFilters stringify into a query param
     * @param page
     * @param count
     * @returns ListManagersRes
     * @throws ApiError
     */
    getListOfManagers(parts, filtersjson, page, count) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/managers/list',
            query: {
                'parts[]': parts,
                'filtersjson': filtersjson,
                'page': page,
                'count': count,
            },
        });
    }
    /**
     * Returns managers information by ids
     * @param ids managers uuids
     * @param parts Manager relation atributes list
     * @returns ManagerResponse
     * @throws ApiError
     */
    getBulkManagers(ids, parts) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/managers/bulk',
            query: {
                'ids[]': ids,
                'parts[]': parts,
            },
        });
    }
    /**
     * Returns manager information by id.
     * @param id manager uuid
     * @param parts Manager relation atributes list
     * @returns ManagerResponse
     * @throws ApiError
     */
    getManager(id, parts) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/managers/{id}',
            path: {
                'id': id,
            },
            query: {
                'parts[]': parts,
            },
        });
    }
    /**
     * Updates manager information by id.
     * @param id manager uuid
     * @param requestBody
     * @returns UpdateManagerRes
     * @throws ApiError
     */
    updateManager(id, requestBody) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/managers/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Delete manager information by id.
     * @param id manager uuid
     * @returns DeleteResponse
     * @throws ApiError
     */
    deleteManager(id) {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/managers/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Returns manager information by id.
     * @param userId manager user uuid
     * @param parts Manager relation atributes list
     * @returns ManagerResponse
     * @throws ApiError
     */
    getManagerByUserId(userId, parts) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/managers/user/{userId}',
            path: {
                'userId': userId,
            },
            query: {
                'parts[]': parts,
            },
        });
    }
}
exports.ManagersService = ManagersService;
